import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-answer-form',
  templateUrl: './answer-form.component.html',
  styleUrls: ['./answer-form.component.css']
})
export class AnswerFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
